<template>
  <q-card class="article-card">
    <q-item
      clickable
      class="q-px-sm"
      @click="goToHref(article.url, true, false, 'width=1024,height=1024,left=300')"
    >
      <q-item-section
        v-if="article.icon"
        top
        side
      >
        <q-icon :name="article.icon" />
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-bold text-clickable">
          {{ article.title }}
        </q-item-label>
        <q-item-label
          v-if="breadcrumb"
          caption
          class="opaque-70"
        >
          {{ article.breadcrumb }}
        </q-item-label>
        <q-item-label
          v-if="article.description"
          caption
          class="article-excerpt"
        >
          {{ article.description }}
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-card>
</template>

<script>
export default {
  props: {
    article: {
      type: Object,
      required: true
    },
    breadcrumb: {
      type: Boolean,
      default: false
    }
  }
}
</script>
